import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch, Redirect, useHistory } from "react-router-dom";
import * as Cookie from "js-cookie";
import { Config } from "./models/config";
import { configService } from "./services/configService";
import Home from "./components/home/Home";
import Unauthorized from "./components/unauthorized/Unauthorized";

const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [checked, setChecked] = useState(false);
  const [authenticated, setAuthenticated] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const config: Config = configService.getConfig();
    const accessToken = Cookie.get("accessToken");
    if (accessToken && config.validatorURL) {
      fetch(config.validatorURL, {
        headers: { Authorization: "Bearer " + accessToken },
      })
        .then((res) => {
          if (!res.ok) {
            setAuthenticated(false);
            history.push("/unauthorized");
          }
          setChecked(true);
        })
        .catch(() => {
          setAuthenticated(false);
          history.push("/unauthorized");
          setChecked(true);
        });
    } else {
      // If no token or validator URL, allow access (dev mode)
      setChecked(true);
    }
  }, [history]);

  if (!checked) return null;
  if (!authenticated) return null;
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <AuthGuard>
            <Home />
          </AuthGuard>
        </Route>
        <Route path="/unauthorized">
          <Unauthorized />
        </Route>
        <Route path="/home">
          <AuthGuard>
            <Home />
          </AuthGuard>
        </Route>
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
